<template>
    <div
            :data-displaySingleImage="displaySingleImage"
            :data-hideOnBalloon="hideOnBalloon"
    >
        <template v-if="!propertyImagesLoaded">
            <b-skeleton-img
                    width="252"
                    height="150"
            />
        </template>

        <template v-if="propertyImagesLoaded && !images.length">
            <div class="property-no-image">
                <img
                        :src="require('./../../../assets/images/property_default.jpg')"
                        class="no-image-placeholder"
                >
                <i class="far fa-image" />
                <span class="no-photo-text"> No Photo</span>
            </div>
        </template>

        <template v-if="propertyImagesLoaded && images.length === 1">
            <b-img
                    class="image-carousel w-100"
                    height="150"
                    :src="images[0]"
            />
        </template>

        <template v-if="propertyImagesLoaded && images.length > 1">
            <b-carousel
                    controls
                    indicators
                    :interval="0"
                    class="image-carousel m-0"
            >
                <b-carousel-slide
                        v-for="(image, index) in images"
                        :key="index"
                >
                    <template #img>
                        <component
                                :is="index ? 'b-img-lazy' : 'b-img'"
                                :src="image"
                                class="img-fluid w-100"
                                @error="() => onImgLoadError(index)"
                        />
                    </template>
                </b-carousel-slide>
            </b-carousel>
        </template>
    </div>
</template>

<script>
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    export default {
        name: "PropertyListingCardCarousel",
        props: {
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value) {
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
            hideOnBalloon: {
                type: Boolean,
                required: true,
            },
            displaySingleImage: {
                type: Boolean,
                required: true,
            },
            showControls: {
                type: Boolean,
                default: true,
            },
            itemsCount: {
                type: [Number, String],
                default: 4
            }
        },

        data() {
            return {
                propertyImagesLoaded: false,
                propertyImages: [],
            };
        },

        computed: {
            images() {
                return this.propertyImages
                    .slice(0, this.itemsCount)
                    .map(propertyImg => {
                        let url = new URL(propertyImg);
                        url.searchParams.append('width', 252);
                        url.searchParams.append('height', 150);
                        return url.href;
                    });
            }
        },

        beforeMount() {
            this.setPropertyImages();
        },

        methods: {
            async setPropertyImages() {
                this.propertyImages = await this.propertyAppResource.getImages(parseInt(this.itemsCount));
                this.propertyImagesLoaded = true;
            },
            /**
             * @param imgIndex
             */
            onImgLoadError(imgIndex) {
                this.propertyImages.splice(imgIndex, 1);
            },
        }
    };
</script>
